"use client";
import SvgFileDownloadFilled from "./file_download-filled.svg.js";
import SvgFileDownloadOutlined from "./file_download-outlined.svg.js";
import SvgFileDownloadRound from "./file_download-round.svg.js";
import SvgFileDownloadSharp from "./file_download-sharp.svg.js";
import SvgFileUploadFilled from "./file_upload-filled.svg.js";
import SvgFileUploadOutlined from "./file_upload-outlined.svg.js";
import SvgFileUploadRound from "./file_upload-round.svg.js";
import SvgFileUploadSharp from "./file_upload-sharp.svg.js";
const file_download = {
  filled: SvgFileDownloadFilled,
  outlined: SvgFileDownloadOutlined,
  round: SvgFileDownloadRound,
  sharp: SvgFileDownloadSharp
};
const file_upload = {
  filled: SvgFileUploadFilled,
  outlined: SvgFileUploadOutlined,
  round: SvgFileUploadRound,
  sharp: SvgFileUploadSharp
};
export {
  file_download,
  file_upload
};
